<template>
    <div class="container">
        <div class="number_group f-b">
            <div class="number" @click="selectedValueChange('visitorQty')" :class="{selected: selectedValues.includes('visitorQty')}">
                <div>
                    访客
                    <el-tooltip class="item" effect="dark" content="在统计时间内访问官网的所有用户记录（包含访客）" placement="top">
                        <i class="el-icon-question"></i>
                    </el-tooltip>
                </div>
                <div>{{ topNum.visitorQty || 0 }}</div>
            </div>
            <div class="number" @click="selectedValueChange('registerQty')" :class="{selected: selectedValues.includes('registerQty')}">
                <div>
                    注册量
                    <el-tooltip class="item" effect="dark" content="在统计时间内注册kaka的用户数量" placement="top">
                        <i class="el-icon-question"></i>
                    </el-tooltip>
                </div>
                <div>{{ topNum.registerQty || 0 }}</div>
            </div>
            <div class="number" @click="selectedValueChange('createOrderQty')" :class="{selected: selectedValues.includes('createOrderQty')}">
                <div>
                    订单
                    <el-tooltip class="item" effect="dark" content="在统计时间内创建的所有订单（含未付款、已取消）" placement="top">
                        <i class="el-icon-question"></i>
                    </el-tooltip>
                </div>
                <div>{{ topNum.createOrderQty || 0 }}</div>
            </div>
            <div class="number" @click="selectedValueChange('rate')" :class="{selected: selectedValues.includes('rate')}">
                <div>
                    注册转换率
                    <!-- <el-tooltip class="item" effect="dark" content="订单转换率=下单买家/访客数,以订单为单位，一个用户产生了两个订单，则计数为2" placement="top">
                        <i class="el-icon-question"></i>
                    </el-tooltip> -->
                    <el-tooltip class="item" effect="dark" content="注册转换率= 注册量/访客" placement="top">
                        <i class="el-icon-question"></i>
                    </el-tooltip>
                </div>
                <div>{{ (topNum.rate || 0) | toPercentage }}</div>
            </div>
            <div class="number" @click="selectedValueChange('orderAmount')" :class="{selected: selectedValues.includes('orderAmount')}">
                <div>
                    总销售额
                    <el-tooltip class="item" effect="dark" content="在统计时间（PT）内总的销售额" placement="top">
                        <i class="el-icon-question"></i>
                    </el-tooltip>
                </div>
                <div>{{ topNum.orderAmount || 0 }}</div>
            </div>
        </div>
        <div id="myChart"></div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            myChart: null,
            selectedValues: ['visitorQty'],
            topNum: {
                visitorQty: 0,
                registerQty: 0,
                createOrderQty: 0,
                orderAmount: 0,
                rate: 0
            },
            dataList: []
        }
    },
    computed: {
        chartTitle() {
            const obj = {
                visitorQty: '访客',
                registerQty: '注册量',
                createOrderQty: '订单',
                orderAmount: '总销售额',
                rate: '注册转换率'
            }
            return obj[this.selectedValues[0]]
        },
        yAxisMapping() {
            let arr = []
            if(['访客', '注册量', '订单', '总销售额'].includes(this.chartTitle)) {
                arr = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45]
            } else {
                arr = [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9 ,1]
            }
            return arr
        }
    },
    filters: {
        toPercentage(value) {
            return `${(value*100).toFixed(2)}%`
        }
    },
    methods: {
        selectedValueChange(value) {
            this.selectedValues = [value]
            this.drawChart(this.dataList)
        },
        setTopNum(topNum) {
            this.topNum = topNum || {}
        },
        drawChart(dataList) {
            this.dataList = dataList
            // 注册转换率= 注册量/访客
            this.myChart = this.$echart.init(document.getElementById('myChart'))
            let options = this.generateOption(dataList)
            this.myChart.setOption(options)
        },
        generateOption(dataList) {
            const options = {
                title: {
                    text: this.chartTitle,
                    left: '2%',
                    top: '1%'
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                    saveAsImage: {}
                    }
                },
                xAxis: {
                    type: 'category',
                    data: dataList.map(e=>e.datePeriod)
                },
                yAxis: {
                    type: 'value',
                    data: this.yAxisMapping
                },
                tooltip: {
                    trigger: 'axis'
                },
                series: [
                    {
                        data: dataList.map(e=>e[this.selectedValues[0]]),
                        type: 'line',
                        name: this.chartTitle
                    }
                ]
            }
            return options
        }
    }
}
</script>

<style lang="scss" scoped>
.container {
    .number_group {
        margin-bottom: 10px;
        .number {
            margin-right: 20px;
            flex: 1;
            background-color: #fff;
            padding: 22px 30px;
            border: 1px solid transparent;
            box-shadow: 5px 5px 5px #ebeef5;
            border-radius: 5px;
            transition: all .5s;
            >div:nth-of-type(2) {
                font-weight: bold;
                margin-top: 6px;
            }
        }
        >.number:last-of-type {
            margin-right: 0px;
        }
        .number:hover{
            border-color: #99c41c;
            opacity: .7;
        }
        .selected {
            border-color: #99c41c !important;
        }
    }
    #myChart{
        width: 100%;
        height: 550px;
        background-color: #fff;
    }
}
</style>